export default __webpack_public_path__ + "static/media/graphicdesign.fd4cacf2.jpg";